import { MutationTree } from "vuex";
import {
	ReportState,
	ReportTitles,
	ReportFilterQuery,
	ReportUpdateFilterQuery,
	CustomReportModal,
	ShareCustomReportModal,
	ShareWithUsers,
	FavoriteReportModal,
	ReportHistoryModal,
	ReportFavoriteData
} from "./types";
import { getDefaultState } from "./state";

export const mutations: MutationTree<ReportState> = {
	setAvailableReports(state, reports: any[]) {
		state.AvailableReports = reports;
	},

	setReport(state, report: any) {
		state.Report = report;
	},

	setRelativeDaysToReport(state, days: number) {
		state.RelativeDaysToReport = days;
	},

	setCurrentReportUrl(state, url: string) {
		state.CurrentReportUrl = url;
	},

	setResultCountNumber(state, count: number) {
		state.ResultCount = count;
	},

	setReportLoadingStatus(state, status: boolean) {
		state.ReportLoadingStatus = status;
	},

	setReportErrorStatus(state, status: boolean) {
		state.ReportErrorStatus = status;
	},

	setReportApiEndpoint(state, endpoint: string) {
		state.ReportApiEndpoint = endpoint;
	},

	setReportTypes(state, types: []) {
		state.ReportTypes = types;
	},

	setFavoriteReports(state, favorites: ReportFavoriteData[]) {
		state.FavoriteReports = favorites
	},

	setReportsCustomTitle(state, customTitle: string) {
		state.Report.customTitle = customTitle;
	},

	setReportTypeCustomTitle(state, titles: ReportTitles) {
		state.ReportTypes.forEach(reportType => {
			const report = reportType.types.find(x => x.title == titles.title);
			if (report) {
				report.customTitle = titles.customTitle;
			}
		});
	},

	setFilterInsightaData(state, payload: ReportFilterQuery | ReportUpdateFilterQuery) {
		if (!state.Report || !state.Report.filterOptions) return;
		const currentFilter = state.Report.filterOptions.find(filter => filter.filterName == payload.filterName);
		if (!currentFilter) return;
		currentFilter.data = payload.data;
	},

	setReportDatePref(state, datePref: boolean) {
		state.ReportDateFormatPref = datePref;
	},

	setCustomReportModalShown(state, customReport: CustomReportModal) {
		state.CustomReportModal = customReport;
	},

	setShareCustomReportModalShown(state, shareReport: ShareCustomReportModal) {
		state.ShareCustomReportModal = shareReport;
	},

	setShareWithUsers(state, users: ShareWithUsers[]) {
		state.ShareWithUsers = users;
	},

	setFavoriteReportModalShown(state, favoriteReport: FavoriteReportModal) {
		state.FavoriteReportModal = favoriteReport;
	},

	setReportHistoryModalShown(state, historyModal: ReportHistoryModal) {
		state.ReportHistoryModal = historyModal;
	},

	resetState(state) {
		Object.assign(state, getDefaultState());
	}
};
